import { render, staticRenderFns } from "./HOGCLogo.vue?vue&type=template&id=44cbcc22&"
import script from "./HOGCLogo.vue?vue&type=script&lang=js&"
export * from "./HOGCLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports